import React from 'react'
import BuildControl from './BuildControl/BuildControl'

import './BuildControls.scss'

const controls = [
    {
        label: 'Salad', type: 'salad'
    },
    {
        label: 'Bacon', type: 'bacon'
    },
    {
        label: 'Cheese', type: 'cheese'
    },
    {
        label: 'Meat', type: 'meat'
    },
]

const BuildControls = (props) => (
        <div className="BuildControls">
            <p>Current Price: <strong>${props.totalPrice.toFixed(2)}</strong></p>
            {controls.map(ctrl => (
                <BuildControl key={ctrl.label} 
                              label={ctrl.label}
                              added={() => props.ingredientAdded(ctrl.type)}
                              removed={() => props.ingredientRemoved(ctrl.type)}
                              disableLess={props.disableLess[ctrl.type]}
                              disableMore={props.disableMore[ctrl.type]}
                />
            ))}
            <button 
                className="OrderButton" 
                disabled={props.disabledOrder}
                onClick={props.openModal}
            >{props.isAuth ? "ORDER NOW" : "SIGN UP TO ORDER" }</button>
        </div>
    )

export default BuildControls
